import { render } from "./FolderTree.vue?vue&type=template&id=5f406812&scoped=true"
import script from "./FolderTree.vue?vue&type=script&lang=js"
export * from "./FolderTree.vue?vue&type=script&lang=js"

import "./FolderTree.vue?vue&type=style&index=0&id=5f406812&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f406812"]])

export default __exports__